import { render, staticRenderFns } from "./TranslationsDisplay.vue?vue&type=template&id=8f1e87ce"
import script from "./TranslationsDisplay.vue?vue&type=script&lang=js"
export * from "./TranslationsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports